import React from 'react';
import { GetStaticProps } from 'next';
import { bffService, Wrapper } from '@thisisdevelopment/akzonobel-core';
import {
  CmsSections,
  CmsSectionType,
  CmsVideo,
  Page,
} from '@thisisdevelopment/heritage-core-library';
import { PageUnavailable } from '@/components/PageUnavailable';
import { Banner } from '@/pages/OurProducts/styled';
import NextHead from '@/components/NextHead';
import metas from '@/routes/meta';
import { pageRevalidate } from '../../../src/config';

export type OurProductsType = {
  title: string;
  banner: number;
  headline: string;
  video_cover: number;
  video: number;
  sections: CmsSectionType[];
  product_list_background: number;
};

type SSRPageProps = {
  page: OurProductsType | null;
};

const OurProducts = ({ page }: SSRPageProps) => {
  const meta = metas.ourProducts;

  if (!page) return <PageUnavailable />;

  return (
    <div>
      <NextHead meta={meta} />
      <Page title={page.title} headline={page.headline}>
        <Banner id={page.banner} alt="Banner" />
        <Wrapper mb="30px">
          <CmsSections sections={page.sections} />
        </Wrapper>
        <CmsVideo coverId={page.video_cover} videoId={page.video} mb="50px" />
      </Page>
    </div>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const resp = await bffService
    .getCmsItem('our_products')
    .then((res) => res.data.data[0])
    .catch(() => null);

  if (!resp) {
    return { notFound: true };
  }

  return {
    props: { page: resp },
    revalidate: pageRevalidate,
  };
};

export default OurProducts;
